import React, { useState, useEffect } from "react";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import CustomButton from "../../components/form/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showFormErrors } from "../../helpers/showFormErrors";
import CustomInput from "../../components/form/CustomInput";
import { categoriesResource, departmentsResource } from "../../helpers/configRoutes/backend_helper";
import { reset_category } from "../../store/categories/action";
import { FileInput } from "lucide-react";
import CustomSelect from "../../components/form/CustomSelect";

const ModalNewCategory = ({ modal, setModal, filters, setFilters }) => {
    const dispatch = useDispatch()

    const { category, validations } = useSelector((state) => state.Category)

    const [loading, setLoading] = useState(false);
    const [departments, setDepartment] = useState([]);
    const validation = useFormik({
        initialValues: category,
        validationSchema: Yup.object().shape({
            ...validations
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);
            const response = await categoriesResource((values.id ? 'put' : 'post'), values, values.id)
            if (response.status) {
                setFilters({ ...filters })
                dispatch(reset_category())
                setModal({ ...modal, show: false })
            }
            setLoading(false);
        }
    });

    useEffect(() => {
        const getCatalogs = async () => {
            const response = await departmentsResource('get', {});
            setDepartment(response.departments);
        };
        getCatalogs();
    }, []);


    return (
        <BaseModalAnimated setModal={setModal} modal={modal}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    showFormErrors(validation);
                    return false;
                }}
            >
                <div className="px-6 py-5 space-y-6 bg-fr-light text-fr-dark">
                    <h2 className="text-lg font-semibold text-center">
                        {category.id ? "Editar área" : "Crear área"}
                    </h2>

                    {/* Inputs: 2 en fila + 1 debajo */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <CustomInput
                            label={"Nombre"}
                            type="text"
                            name="name"
                            error={validation?.errors?.name}
                            value={validation?.values?.name}
                            handleChange={validation.handleChange}
                            className="text-sm"
                        />
                        <CustomInput
                            label={"Codigo de productos"}
                            type="text"
                            name="code"
                            error={validation?.errors?.code}
                            value={validation?.values?.code}
                            handleChange={validation.handleChange}
                            className="text-sm"
                        />
                    </div>
                    <div>
                        <CustomSelect
                            label="Departamentos"
                            options={departments}
                            name="department_id"
                            value={validation.values.department_id}
                            error={validation.errors.department_id}
                            handleChange={validation.handleChange}
                        />
                    </div>
                </div>

                <div className="px-6 py-4 bg-fr-secondary border-t border-fr-muted flex justify-end gap-3 rounded-b-lg">
                    <CustomButton
                        loading={loading}
                        textLoad="Guardando"
                        className="bg-fr-primary hover:bg-fr-primary-hover text-fr-light px-6 py-2 rounded-lg text-sm transition-all shadow"
                        type="submit"
                    >
                        Guardar
                    </CustomButton>

                    <CustomButton
                        className="bg-fr-danger hover:bg-red-600 text-fr-light px-6 py-2 rounded-lg text-sm transition-all shadow"
                        onClick={() => setModal({ ...modal, show: false })}
                        type="button"
                    >
                        Cancelar
                    </CustomButton>
                </div>
            </form>

        </BaseModalAnimated>
    );
};

export default ModalNewCategory;
